var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[(!_vm.errorFlag)?_c('van-loading',{attrs:{"color":"#1989fa","size":"48px"}},[_vm._v("加载中...")]):_c('div',{staticStyle:{"font-size":"20px","font-weight":"550"}},[_vm._v(" "+_vm._s(_vm.errorMsg)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }